var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAvatarChat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_avatar_chat_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_avatar_chat_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_pattern_704680",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.18 0 8.91 0 0 9.39 0 6.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "35.55 0 38.33 0 29.5 8.92 20.69 0 23.49 0 29.55 6.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "65.52 0 68.33 0 59.5 8.92 50.67 0 53.48 0 59.5 6.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "90 6.55 90 9.39 80.68 0 83.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "90 21.55 90 24.39 74.5 8.77 59.5 23.92 44.5 8.77 29.5 23.92 14.68 8.92 0 24.39 0 21.55 14.59 6.08 29.55 21.08 44.51 5.93 59.5 21.08 74.5 5.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "90 36.55 90 39.39 74.5 23.77 59.5 38.92 44.5 23.77 29.5 38.92 14.68 23.92 0 39.39 0 36.55 14.59 21.08 29.55 36.08 44.51 20.93 59.5 36.08 74.5 20.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "90 51.55 90 54.39 74.5 38.77 59.5 53.92 44.5 38.77 29.5 53.92 14.68 38.92 0 54.39 0 51.55 14.59 36.08 29.55 51.08 44.51 35.93 59.5 51.08 74.5 35.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "90 66.55 90 69.39 74.5 53.77 59.5 68.92 44.5 53.77 29.5 68.92 14.68 53.92 0 69.39 0 66.55 14.59 51.08 29.55 66.08 44.51 50.93 59.5 66.08 74.5 50.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "90 81.55 90 84.39 74.5 68.77 59.5 83.92 44.5 68.77 29.5 83.92 14.68 68.92 0 84.39 0 81.55 14.59 66.08 29.55 81.08 44.51 65.93 59.5 81.08 74.5 65.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "14.59 81.08 23.49 90 20.69 90 14.68 83.92 8.91 90 6.18 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "44.51 80.93 53.48 90 50.67 90 44.5 83.77 38.33 90 35.55 90"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "83.5 90 80.68 90 74.5 83.77 68.33 90 65.52 90 74.5 80.93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatarChat2);
export default __webpack_public_path__ + "static/media/icon_avatar_chat_2.25b4f06b2a38df7acdd792ab658de16c.svg";
export { ForwardRef as ReactComponent };